export default function Machines_A_8 (number = 1) {
  return {
    name: '射线接收站',
    icon: '/static/img/machines/a8.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_8.js